import React from "react";
import cn from "classnames";
import { Check, CheckCheck, FileXIcon, Info, Loader2 } from "lucide-react";
import ChatFileItem from "../ChatFileItem";
import style from "./ChatMessage.module.scss";

const ChatMessage = ({ message, files = [], isChatFilesLoading = false, onDownloadFile, t }) => {
  const messageFiles = message.files && message.files.length > 0 ? message.files : files;
  const hasFiles = messageFiles.length > 0;
  const hasText = message.text && message.text.trim().length > 0;
  const isSending = message.status === "sending";
  const isFileMessage = message.messageType?.toLowerCase() === "file";
  const isFilePending = isFileMessage && !hasFiles && isChatFilesLoading;
  const isFileMissing = isFileMessage && !hasFiles && !isChatFilesLoading && message.sent;

  if (message.isSystem) {
    return (
      <div className={style.system_message}>
        {hasText && <span className={style.system_message_text}>{message.text}</span>}
        {message.time && <span className={style.system_message_time}>{message.time}</span>}
      </div>
    );
  }

  return (
    <div
      className={cn(style.message, {
        [style.sent]: message.sent,
        [style.received]: !message.sent,
      })}
    >
      <div className={style.message_content_row}>
        {isFileMissing && (
          <span className={style.file_error_info_icon} aria-hidden="true">
            <Info size={14} />
          </span>
        )}

        <div
          className={cn(style.message_bubble, {
            [style.sent]: message.sent,
            [style.received]: !message.sent,
            [style.file_error_bubble]: isFileMissing,
          })}
        >
          {hasText && <div className={style.message_text}>{message.text}</div>}

          {isFilePending && (
            <div className={style.file_pending}>
              <Loader2 size={16} className={style.spinner} />
              <span>{t("orderChat.file")}...</span>
            </div>
          )}

          {isFileMissing && (
            <div className={style.file_error} role="alert">
              <FileXIcon size={22} className={style.file_error_file_icon} aria-hidden="true" />
              <span className={style.file_error_content}>
                <span className={style.file_error_title}>{t("orderChat.fileSendFailed")}</span>
                <span className={style.file_error_hint}>{t("orderChat.tryAgain")}</span>
              </span>
            </div>
          )}

          {hasFiles && (
            <div className={style.files_container}>
              {messageFiles.map((file, index) => (
                <ChatFileItem
                  key={file.id || index}
                  file={file}
                  onDownload={onDownloadFile}
                  isSent={message.sent}
                  t={t}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <div className={style.message_time_wrapper}>
        <span className={style.message_time}>{message.time}</span>
        {message.sent && (
          <div className={style.message_status_icon}>
            {isSending ? (
              <Loader2 size={14} className={style.spinner} />
            ) : message.status === "read" ? (
              <CheckCheck size={16} color="#155DFC" />
            ) : (
              <Check size={16} color="#99A1AF" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
